import { useState, useEffect, useCallback } from 'react';
import { message } from 'antd';
import API from '@/api/api';

export function useVendorCodesData() {
  const [vendorCodes, setVendorCodes] = useState([]);
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(async (signal) => {
    setLoading(true);
    try {
      const vendorCodesPromise = API.get('/admin/vendor_codes', { signal });
      const projectsPromise = API.get('/admin/projects', { signal });

      const [vendorCodesRes, projectsRes] = await Promise.all([vendorCodesPromise, projectsPromise]);

      setVendorCodes(vendorCodesRes.data || []);
      setProjects(projectsRes.data || []);
    } catch (error) {
      if (error.name !== 'CanceledError') {
        message.error('벤더코드 및 프로젝트 목록 조회에 실패했습니다.');
      }
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchData(controller.signal);

    return () => {
      controller.abort();
    };
  }, [fetchData]);

  return { vendorCodes, projects, loading, refetch: fetchData };
}
